import { serializable, alias, object, list, primitive } from "serializr";
import { IdNameModel } from "./branches.model";
class Board {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("acronym", primitive()))
  acronym?: string;

  @serializable(alias("name", primitive()))
  name?: string;
}
class Branch {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;
}
class ClassRoom {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;
}
class ClassRoomSubjects extends IdNameModel {

  @serializable(alias("class_room_subject_id", primitive()))
  classRoomSubjectId?: number;

}
class Exams {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("acronym", primitive()))
  acronym?: string;

  @serializable(alias("amount_cents", primitive()))
  amountCents?: number;

  @serializable(alias("amount_currency", primitive()))
  amountCurrency?: string;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("id", primitive()))
  examId?: number;
}
export class Sections {
  @serializable(alias("id", primitive()))
  id?: number;
  
  @serializable(alias("id", primitive()))
  key?: number;

  @serializable(alias("branch", object(Branch)))
  branch?: Branch;

  @serializable(alias("board", object(Board)))
  board?: Board;

  @serializable(alias("branch_class_room", object(ClassRoom)))
  branchClassRoom?: ClassRoom;

  @serializable(alias("class_room", object(ClassRoom)))
  classRoom?: ClassRoom;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("section_subjects", list(object(ClassRoomSubjects))))
  classRoomSubjects?: ClassRoomSubjects[] = [];

  @serializable(alias("exams", list(object(Exams))))
  exams?: Exams[] = [];

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;
}

export class SectionSubjects {
  @serializable(alias("class_room_subject_id", primitive()))
  classRoomSubjectId?: number;
}

export class SectionExams {
  @serializable(alias("exam_id", primitive()))
  examId?: number;
}
export class Section {
  @serializable(alias("branch_id", primitive()))
  branchId?: number;

  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoomId?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("section_subjects", list(object(SectionSubjects))))
  sectionSubjects?: SectionSubjects[] = [];

  @serializable(alias("section_exams", list(object(SectionExams))))
  sectionExams?: SectionExams[] = [];

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;
}
export class SectionSubjectMetaModel {
  @serializable(alias("id", primitive()))
  classRoomSubjectId?: number;
}
export class SectionExamMetaModel {
  @serializable(alias("id", primitive()))
  examId?: number;
}
export class SectionMeta {
  @serializable(alias("id", primitive()))
  value?: number;

  @serializable(alias("name", primitive()))
  label?: string;

  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoomId?: number;
}
